module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contacts-section"
  }, [_c('x-table', {
    attrs: {
      "title": _vm.$t('ui.contacts.title'),
      "emptyStateLabel": _vm.$t('ui.contacts.empty_state_msg'),
      "columns": _vm.filteredColumns(_vm.columns),
      "tableData": _vm.contacts,
      "enableSearch": true,
      "searchKeywords": _vm.segment.search,
      "enableFilter": true,
      "filterDefinitions": _vm.getFilterDefinitions(),
      "filters": _vm.segment.filters,
      "selectionType": "multiple",
      "totalResults": _vm.totalCount,
      "pagination": _vm.defaultPagination,
      "showLoader": _vm.loading,
      "actions": _vm.actions,
      "tableSettingsName": _vm.tableSettingsName,
      "rowsPerPage": [5, 7, 10, 15, 25, 50]
    },
    on: {
      "updateSearch": _vm.updateSearch,
      "updateFilters": _vm.updateFilters,
      "updatePagination": _vm.updatePagination,
      "fetchData": _vm.fetchData,
      "clickCell": _vm.clickCell,
      "emitTotalTableCount": _vm.emitTotalTableCount,
      "selectedItemsChange": _vm.selectedItemsChange
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "open": _vm.deleteContactsModalOpen,
      "title": _vm.$t('ui.contacts.modals.delete.title'),
      "type": "warning",
      "showCancelForWarning": true,
      "saveText": _vm.$t('ui.global.delete')
    },
    on: {
      "save": _vm.actionDelete,
      "cancel": _vm.closeDeleteContactsModal
    }
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.$t("ui.global.delete_confirmation", {
    name: _vm.$tc("ui.contacts.enumeration", _vm.currentSelectedIds.length, {
      n: _vm.currentSelectedIds.length
    })
  })) + "\n    ")])]), _vm._v(" "), _c('change-company', {
    attrs: {
      "isOpen": _vm.companyChangeOpen,
      "idCount": _vm.selectedIdCount
    },
    on: {
      "cancel": function($event) {
        return _vm.showCompanyChange(false)
      },
      "save": _vm.emitId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01bd892e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/FilterResults/Contacts.vue
// module id = 1792
// module chunks = 0